module.exports = __webpack_public_path__ + "img/btn_sound.083a76eb.png";